import './CardMultipleCard.css';
import React from 'react';
import RouterLink from '../../../atoms/RouterLink';
import { get } from '../../../../utils/getPropertyByPath';
import { useSitecoreContext } from '../../../../utils/SitecoreContextReactContext';
var CardMultipleCard = function CardMultipleCard(_ref) {
  var cardIcon = _ref.cardIcon,
    title = _ref.title,
    description = _ref.description,
    ctaLabel = _ref.ctaLabel,
    ctaLink = _ref.ctaLink,
    analyticsHandler = _ref.analyticsHandler;
  var sitecoreContext = useSitecoreContext();
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var titleValue = get(title, "jss.value");
  var descriptionValue = get(description, "jss.value");
  var ctaLabelValue = get(ctaLabel, "jss.value");
  var cardIconSrcValue = get(cardIcon, "jss.value.src");
  var cardIconAltValue = get(cardIcon, "jss.value.alt");
  var ctaLinkHrefValue = get(ctaLink, "jss.value.href");
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "cardWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "imageWrapper"
  }, /*#__PURE__*/React.createElement("img", {
    className: "image",
    src: cardIconSrcValue,
    alt: cardIconAltValue
  })), /*#__PURE__*/React.createElement("h4", {
    className: "title"
  }, titleValue), /*#__PURE__*/React.createElement("p", {
    className: "description ellipsis"
  }, descriptionValue), /*#__PURE__*/React.createElement(RouterLink, {
    href: ctaLinkHrefValue,
    onClick: function onClick() {
      return analyticsHandler([titleValue, ctaLabelValue]);
    }
  }, /*#__PURE__*/React.createElement("p", {
    className: "ctaText"
  }, ctaLabelValue))));
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  var props = {
    className: "".concat(commonStyles, " ").concat(rtl ? rtlStyles : ltrStyles),
    children: children
  };
  return /*#__PURE__*/React.createElement("div", props);
};
var commonStyles = "cqs8tc1";
var ltrStyles = "l1eoflqk";
var rtlStyles = "r1ygyvnr";
export { CardMultipleCard };